import request from './request'

export function fetchYoutubeTags() {
  return request({
    url: '/api/youtube/tags',
    method: 'get',
  })
}

export function fetchYoutubeChannels() {
  return request({
    url: '/api/youtube/channels',
    method: 'get',
  })
}

export function fetchYoutubeList(params) {
  return request({
    url: '/api/youtube/list',
    method: 'get',
    params,
  })
}

export function fetchYoutubeDetail(id) {
  return request({
    url: '/api/youtube/detail',
    method: 'get',
    params: {
      id,
    },
  })
}

export function saveYoutubeBreakdown(payload) {
  return request({
    url: '/api/youtube/breakdown/save',
    method: 'post',
    data: payload,
  })
}

export function deleteYoutubeBreakdown(breakdownId) {
  return request({
    url: '/api/youtube/breakdown/delete',
    method: 'post',
    data: {
      breakdownId,
    },
  })
}

export function saveDomainCategoryBreakdown(payload) {
  return request({
    url: '/api/youtube/domain-category-breakdown/save',
    method: 'post',
    data: payload,
  })
}

export function deleteDomainCategoryBreakdown(breakdownId) {
  return request({
    url: '/api/youtube/domain-category-breakdown/delete',
    method: 'post',
    data: {
      breakdownId,
    },
  })
}

export function saveGlobalEssay(payload) {
  return request({
    url: '/api/youtube/global-essay/save',
    method: 'post',
    data: payload,
  })
}

export function deleteGlobalEssay(essayId) {
  return request({
    url: '/api/youtube/global-essay/delete',
    method: 'post',
    data: {
      essayId,
    },
  })
}
